import { Link } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';

export function KpiCard({ title, value, icon: Icon, color = 'text-blue-600', bgColor = 'bg-blue-50', subtitle, link, urgent }) {
  const inner = (
    <Card className={`relative overflow-hidden transition-all duration-300 hover:shadow-lg card-hover ${urgent ? 'ring-2 ring-red-400 animate-pulse' : ''}`}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div className="space-y-1.5">
            <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{title}</p>
            <p className={`text-2xl font-bold tracking-tight tabular-nums ${urgent ? 'text-red-600 dark:text-red-400' : 'text-foreground'}`}>{value}</p>
            {subtitle && <p className="text-[11px] text-muted-foreground">{subtitle}</p>}
          </div>
          <div className={`p-3 rounded-2xl ${bgColor} dark:bg-opacity-20`}>
            <Icon className={`w-5 h-5 ${color}`} strokeWidth={1.5} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
  return link ? <Link to={link} data-testid={`kpi-${title.replace(/\s+/g, '-').toLowerCase()}`}>{inner}</Link> : <div data-testid={`kpi-${title.replace(/\s+/g, '-').toLowerCase()}`}>{inner}</div>;
}
